export interface IColdIschemiaLagTime {
    swapNumber: string,
    crossClampReportTime: string,
    crossClampTime: string,
    donorCenterId: number,
    donorCenter: string,
    remoteDonorCenterId: number,
    remoteDonorCenter: string,
    donorAlias: string,
    recipientCenterId: number,
    recipientCenter: string,
    recipientAlias: string,
    scheduledPickup: string,
    actualPickup: string,
    citLagTimeMinutes: number,
    isCompliant: string
}